/**
 * Normal path for OIDC challenge returnUrl (matches wizard API behavior).
 */
export function normalizeChallengeReturnPath(): string {
  let path = window.location.pathname + window.location.search;
  while (path.includes("/wizard/wizard/")) {
    path = path.replace("/wizard/wizard/", "/wizard/");
  }
  return path;
}

export function redirectToWizardChallenge(): void {
  const returnUrl = encodeURIComponent(normalizeChallengeReturnPath());
  window.location.href = `/api/bridge/wizard/challenge?returnUrl=${returnUrl}`;
}
